import { createContext, HTMLProps } from "react";

type SortableItemContextType = {
  draggableElementProps?: HTMLProps<HTMLDivElement>;
};

export const SortableItemContext = createContext<SortableItemContextType>({ draggableElementProps: undefined });
